export { EyeCatcherView as EyeCatcher } from '@fsf/types';

export const URLs = [
  { key: '/safety-gukeye', value: 'Sicherheitseinweisung und Zertifikat' },
  { key: '/parcours', value: 'Parcours' },
  { key: '/achievements', value: 'Meine Erfolge' },
  { key: '/impressions', value: 'Impressionen' },
  { key: '/good-to-know', value: 'Wissenswertes' },
  { key: '/tickets', value: 'Tickets und Angebote' },
  { key: '/news', value: 'Neuigkeiten' },
  { key: '/contact', value: 'Kontakt und Öffnungszeiten' },
  { key: '/imprint', value: 'Impressum' },
  { key: '/privacy-policy', value: 'Datenschutz' },
  { key: '/join-team', value: 'Werde Teil des Teams' },
];
